import { createPaginatedSlice } from "../../helpers/reduxHelper";

const productBuilderList = createPaginatedSlice('productBuilderList');

export const productBuilderListActions = productBuilderList.actions
export const productBuilderListSelector = state => state.productBuilderList;
export const productBuilderListReducer = productBuilderList.reducer;
export default productBuilderListReducer

export const productBuilderListSelectors = productBuilderList.LF.selectors